
import React, { Component } from 'react';
import { Redirect, Route, Router, Switch } from 'react-router-dom';
import Alert from 'react-s-alert';
import 'react-s-alert/dist/s-alert-css-effects/slide.css';
import 'react-s-alert/dist/s-alert-default.css';
import AppContainer from './AppContainer';
import AuthContext from './auth-context';
import "./css/bootstrap.css";
import "./css/style.css";
import history from './history';
import Login from './Login';
import MainLayout from './MainLayout';
import Home from './Public/HomePage/Home';
import Developers from './Developers/Developers';

const ProtectedRoute  = ({ isAllowed, ...props }) => {
  const redirectTo = `/login`

  // This guard isn't inside a real <Switch>, so its redirect branch fires on
  // every path when logged out. Leave the public docs route alone.
  if (window.location.pathname.startsWith('/developers/')) return null

  return isAllowed
   ? <Route {...props} />
   : <Redirect to={redirectTo} />;
}

class MainRoutes extends Component {
  static contextType = AuthContext;

  render() {
    const authStore = this.context
    let isAllowed = authStore.isAuthenticated()

    return (
      <Router history={history}>
        <>
          <Switch>
            <AppContainer>
              <Route exact path="/" render={(props) => <Home {...props} />} />
              <Route exact path="/login" render={(props) => <Login {...props} />} />
              {/* API docs — outside the login gate; protected by a secret in the URL */}
              <Route path="/developers/:secret" render={(props) => <Developers {...props} />} />

              <ProtectedRoute path="/m1" render={props => <MainLayout {...props}  />} isAllowed={isAllowed} />
            </AppContainer>

          </Switch>
          <Alert stack={{ limit: 3 }} effect='slide' timeout={5000} offset={0} position='bottom-right' />
          </>
      </Router>
    );
  }
}

export default MainRoutes